import { Phone } from "lucide-react";
import { cn } from "@/lib/utils";
import { business } from "@/data/siteConfig";
import { useCallAction } from "@/hooks/useCallAction";

const variants = {
  gold: "bg-gold text-ink hover:bg-gold-dark",
  outline: "border border-white/25 text-white hover:bg-white/10",
  darkOutline: "border border-ink/25 text-ink hover:bg-ink/5",
};

const sizes = {
  md: "h-11 px-6 text-[13px]",
  lg: "h-14 px-8 text-sm md:text-base",
};

export const CallButton = ({
  label = "Call Now",
  showNumber = false,
  variant = "gold",
  size = "md",
  className,
  testid = "call-btn",
}) => {
  const { onCall, tel } = useCallAction();
  return (
    <a
      href={tel}
      onClick={onCall}
      data-testid={testid}
      className={cn(
        "group inline-flex items-center justify-center gap-2.5 rounded-sm font-heading font-bold uppercase tracking-[0.08em] transition-[transform,background-color,border-color,color] duration-300 hover:scale-[1.02] active:scale-95",
        variants[variant],
        sizes[size],
        className,
      )}
    >
      <Phone className="h-4 w-4 transition-transform duration-300 group-hover:-rotate-12" />
      <span>
        {label}
        {showNumber ? ` · ${business.phone}` : ""}
      </span>
    </a>
  );
};

/** Large tappable phone number (copies on desktop, calls on mobile). */
export const PhoneDisplay = ({ className, size = "text-3xl md:text-5xl", testid = "phone-display" }) => {
  const { onCall, tel } = useCallAction();
  return (
    <a
      href={tel}
      onClick={onCall}
      data-testid={testid}
      className={cn(
        "inline-flex items-center gap-3 font-heading font-black tracking-tight text-gold transition-colors duration-300 hover:text-gold-soft",
        size,
        className,
      )}
    >
      <Phone className="h-[0.85em] w-[0.85em]" />
      {business.phone}
    </a>
  );
};
